export default "__VITE_ASSET__BrqUuv$R__"